import { MB, PC } from "./viewport_width";
import { isMobile } from "react-device-detect";

export default function Spacer(props) {
  return (
    <div
      style={{ width: `${(props.width / (isMobile ? MB : PC)) * 100}vw` }}
    ></div>
  );
}
